import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const List: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
}

export const ButtonWithMargin: React.CSSProperties = {
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}
